import styled from 'styled-components'

import Button from '../Button'

export const CardIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  height: 100%;

  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: ${isNaN(marginBottom) ? marginBottom : `${marginBottom}px`};
  `}
`

export const CardIconButton = styled(Button)`
  margin-top: auto;
`
